import { restClient } from '@/Core'
import type { Reaction } from '../Contracts'
import { mapApiReactions, type ApiReaction } from '../Helpers/apiMappers'

interface ToggleReactionResponse {
    reactions?: ApiReaction[]
}

/**
 * Toggles own emoji reaction on a message; returns the fresh aggregate
 * (the backend broadcasts the same aggregate as message:reaction).
 */
export const ToggleReactionTask = async (messageId: string, emoji: string): Promise<Reaction[]> => {
    const response = (await restClient.post(`/services/chat/messages/${messageId}/reactions`, {
        json: { emoji },
    })) as ToggleReactionResponse | null

    return mapApiReactions(response?.reactions)
}
